import React, { useState } from 'react';
import { Switch, useHistory } from "react-router-dom";
import { PictureIcon } from '../../../assets/icons';
import { RouteWithSubRoutes } from '../../../config/Router';
import { Translate } from '../../../language';
import Button from '../../../utils/components/Button/Button';
import localStorage from '../../../utils/hooks/useLocalStorage';

import style from './ZoneRoomAdmin.module.css'
const ZoneAdminRoot = ({ zone, routes }) => {
  const history = useHistory()
  if (!zone._id) {
    return (
      <div className={style.content_error}>
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>
    )
  } else {

    let idAdmin = null

    switch (zone.adminType) {
      case "user":
        idAdmin = zone.adminUserId
        break;
      case "franchise":
        idAdmin = zone.adminFranchiseId
        break;
      case "warehouse":
        idAdmin = zone.adminWarehouseId
        break;
      case "representative":
        idAdmin = zone.adminRepresentativeId
        break;

      default:
        break;
    }
    if(idAdmin!==localStorage().getItem("idProfile")){
      //history.push("/Zones/Zone/"+zone._id)
    }
  }


  return (
    <div className={style.content_general}>
      <div className={style.content_left}>
        <div className={style.content_icon}><PictureIcon className={style.icon} /></div>
        <div className={style.content_list_rooms}>
          <div className={style.title}>
            {Translate('adminZone', 'es')}

          </div>
          <div className={style.roomInfo}>
            <div className={style.create}>
              <div className={style.green}>{zone.name}</div>
            </div>
            <div className={style.roomInfo}>
              <div>{Translate('category', 'es')}</div>
              <div className={style.purple}> {zone.categoryId?.name}</div>
            </div>
          </div>
          <Button onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            history.push(`/Zones/Admin/${zone._id}`)
          }} text={'General'} classNameContent={style.content_button} active={history.location.pathname.includes('Admin')} />
          <Button onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            history.push(`/Zones/Admin/${zone._id}/Members`)
          }} text={'Miembros'} classNameContent={style.content_button} active={history.location.pathname.includes('Members')} />
          <Button onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            history.push(`/Zones/Admin/${zone._id}/Invite`)
          }} text={'Invitar'} classNameContent={style.content_button} active={history.location.pathname.includes('Invite')} />
          <Button onClick={(e) => {
            e.preventDefault(e); e.stopPropagation();
            history.push(`/Zones/Admin/${zone._id}/Requests`)
          }} text={'Solicitudes'} classNameContent={style.content_button} active={history.location.pathname.includes('Requests')} />
          <Button onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            history.push(`/Zones/Admin/${zone._id}/Reports`)
          }} text={'Reportes'} classNameContent={style.content_button} active={history.location.pathname.includes('Reports')} />
          <Button onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            history.push(`/Zones/Admin/${zone._id}/AddMember`)
          }} text={'Agregar miembros'} classNameContent={style.content_button} active={history.location.pathname.includes('AddMember')} />
          {/*    <Button onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            history.push(`/Zones/Admin/${zone._id}/Delete`)
          }} text={'Borrar sala'} classNameContent={style.content_button} theme={'white'} /> */}

        </div>
      </div>
      <div className={style.content_right}>
        <Switch>
          {routes.map((route, i) => (
            <RouteWithSubRoutes key={i} {...route} />
          ))}
        </Switch>
      </div>
    </div>
  )
};

export default ZoneAdminRoot;
